module.exports = __webpack_public_path__ + "img/sm.sm837e64d.svg";